import {
  Button,
  DoterSpecies,
  ModalHeader,
  TextInput,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useEditProfileModal from "./hooks/useEditProfileModalStore"
import ParentAvatarButton from "./ParentAvatarButton"
import SlideUpModal from "../../components/slideUpModal/SlideUpModal"
import useEditParentMutation from "../settings/useEditParentMutation"

const EditProfileModal = () => {
  const {
    isOpen,
    onClose,
    avatar,
    nickname,
    firstName,
    lastName,
    setAvatar,
    setNickname,
    setFirstName,
    setLastName,
    profile,
  } = useEditProfileModal()
  const { t } = useTranslation()

  const editParentMutation = useEditParentMutation()

  const handleSave = async () => {
    if (!profile) return
    await editParentMutation.mutateAsync({
      parentInfo: {
        name: firstName,
        last_name: lastName,
        nickname,
      },
      parentDoter: {
        type: avatar || DoterSpecies.FOX,
        id: profile.user.parent_doter.id,
      },
      userId: profile.user.id,
    })
    onClose()
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
    >
      <ModalHeader title={t("EPM_TITLE")} onClose={onClose} showBorderBottom />
      <div className="flex flex-col gap-4 p-6 pt-4 overflow-y-auto">
        <div className="flex flex-col gap-1">
          <Typography variant="body">{t("EPM_PARENT_AVATAR")}</Typography>
          <Typography variant="bodyXSmall">{t("EPM_AVATAR_HELP")}</Typography>
        </div>
        <div className="flex flex-row w-full gap-1">
          <ParentAvatarButton
            avatar={DoterSpecies.DRAGON}
            isSelected={avatar === DoterSpecies.DRAGON}
            setSelectedParentAvatar={() => setAvatar(DoterSpecies.DRAGON)}
          />
          <ParentAvatarButton
            avatar={DoterSpecies.BEAR}
            isSelected={avatar === DoterSpecies.BEAR}
            setSelectedParentAvatar={() => setAvatar(DoterSpecies.BEAR)}
          />
          <ParentAvatarButton
            avatar={DoterSpecies.FOX}
            isSelected={avatar === DoterSpecies.FOX}
            setSelectedParentAvatar={() => setAvatar(DoterSpecies.FOX)}
          />
        </div>
        <div className="flex flex-col w-full gap-1">
          <Typography variant="body">{t("EPM_FIRST_NAME")}</Typography>
          <TextInput
            name="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder={t("EPM_FIRST_NAME")}
            fullWidth
          />
        </div>
        <div className="flex flex-col w-full gap-1">
          <Typography variant="body">{t("EPM_LAST_NAME")}</Typography>
          <TextInput
            name="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder={t("EPM_LAST_NAME")}
            fullWidth
          />
        </div>
        <div className="flex flex-col w-full gap-1">
          <Typography variant="body">{t("PPS_IN_APP_NICKNAME")}</Typography>
          <Typography variant="bodyXSmall">
            {t("PARENT_AVATAR_NICKNAME_HELP")}
          </Typography>
          <TextInput
            name="nickname"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder={t("EPM_NICKNAME_PLACEHOLDER")}
            fullWidth
          />
        </div>
      </div>
      <div className="flex flex-col px-6 pt-2 pb-6">
        <Button
          text={t("EPM_SAVE_CHANGES")}
          onClick={handleSave}
          buttonType="primary"
          fullWidth
          isLoading={editParentMutation.isLoading}
        />
      </div>
    </SlideUpModal>
  )
}

export default EditProfileModal
